import { render, staticRenderFns } from "./category-alerts-list.vue?vue&type=template&id=58ef4348&"
import script from "./category-alerts-list.vue?vue&type=script&lang=js&"
export * from "./category-alerts-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports